import {ListCustomRequest} from './list-custom-request';

export default ListCustomRequest;
